import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {FlamingoAuthService} from './flamingo-auth.service';

@Injectable()
export class FlamingoAuthGuard implements CanActivate {

  constructor(private authService: FlamingoAuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLogged()) {
      return true;
    }

    this.router.navigate(['/auth']);
    return false;
  }

}
